// extracted by mini-css-extract-plugin
export var button = "_78-0";
export var icon = "_78-1";